import React, {useState} from "react";
import "./../pages/css/detail.css";
import heart from "./../assets/heart.svg";
import heart_line from "./../assets/heart_line.svg";

const DetailItems = ({data, handleItemSelect}) => {
    const [selectedItems, setSelectedItems] = useState([]);

    const toggleSelectedItem = (id) => {
        if (selectedItems.includes(id)) {
            setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
        } else {
            setSelectedItems([...selectedItems, id]);
        }
    };

    return (
        <div className="detail__container grid">
            {data.map((item, index) => (
                <div className="detail__card" key={index}>
                    <img
                        className="choice__button"
                        src={selectedItems.includes(item.id) ? heart : heart_line}
                        onClick={() => {
                            toggleSelectedItem(item.id);
                            handleItemSelect(item.id);
                        }}
                    ></img>
                    <img src={item.image_url} alt="" className="detail__img"/>
                </div>
            ))}
        </div>
    );
};

export default DetailItems;


